export default {
  nav: {
    home: "Home",
    categories: "Categories",
    article: "Guide",
    ctaMain: "Main Site",
    ctaSpreadsheet: "CSSBuy Spreadsheet",
  },
  hero: {
    eyebrow: "CSSBuy Spreadsheet • Research • QC • Shipping",
    title: "CSSBuy Spreadsheet: Find, Compare & Research Products Easily",
    description: "Explore an organized CSSBuy Spreadsheet with product guides, categories, QC info, shipping guidance, warehouse details, reviews and practical tips to research before buying.",
    ctaPrimary: "Explore CSSBuy Spreadsheet",
    ctaSecondary: "Start Beginner Guide",
    trust: "Independent resource • Updated content • Multilingual guides • Safety focused",
    searchPlaceholder: "Search CSSBuy Spreadsheet...",
  },
  categories: {
    title: "Explore CSSBuy Spreadsheet by Category",
    dropdownLabel: "Select a Category",
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  cta: {
    title: "Ready to start your research?",
    description: "Use the CSSBuy Spreadsheet as a starting point to discover categories, compare information and learn how to evaluate products, QC, warehouse and shipping before continuing.",
    button1: "Explore CSSBuy Spreadsheet",
    button2: "Visit Main Website",
    buttonBuy: "Buy It Now",
  },
  article: {
    title: "CSSBuy Spreadsheet Complete Guide",
    description: "Learn how to use the CSSBuy Spreadsheet for product research, category browsing and quality control checks before purchasing.",
    readMore: "Read Full Guide",
  },
  footer: {
    disclaimer: "This website is an independent informational resource and is not the official CSSBuy website.",
    copyright: "© 2026 cssbuybr.fun. All rights reserved.",
  },
  language: "Language",
  articlePage: {
    title: "CSSBuy Spreadsheet Complete Guide: Research Products Smarter in 2026",
    metaDescription: "A comprehensive guide to using CSSBuy Spreadsheet for product research, category browsing and QC checks. Independent resource for 2026.",
    breadcrumb: "Home / Guide",
    published: "Published: January 15, 2026",
    updated: "Last Updated: September 1, 2026",
    backToHome: "← Back to Home",
    sections: {
      intro: {
        title: "What is CSSBuy Spreadsheet?",
        content: "CSSBuy Spreadsheet is a structured resource that helps buyers organize product links, categories, prices and research notes in one place. Instead of searching through multiple platforms and saving scattered links, you can use a spreadsheet to track items by category, compare options and verify details before making a purchase decision. This guide explains how to use CSSBuy Spreadsheet effectively for product research in 2026.",
      },
      research: {
        title: "How to Research Products with CSSBuy Spreadsheet",
        content: "Effective product research starts with organizing your search. When using CSSBuy Spreadsheet, begin by selecting a category that matches what you are looking for. Browse the available items, compare prices across different sources and check the product details carefully. Look for size charts, material descriptions and seller information. Always verify the current price and availability before proceeding, as spreadsheet information may change over time.",
      },
      categories: {
        title: "Using Categories for Better Organization",
        content: "Categories help you navigate large product collections efficiently. Whether you are searching for shoes, hoodies, jackets or accessories, starting with a category filter saves time. Each category in the CSSBuy Spreadsheet contains relevant items grouped together, making it easier to compare similar products and identify the best options for your needs.",
      },
      qc: {
        title: "QC Photos and Quality Control",
        content: "Quality Control (QC) photos are essential for verifying product condition before shipment. When researching through CSSBuy Spreadsheet, always check if QC photos are available for the items you are interested in. Review the images carefully for stitching, material quality, color accuracy and any visible defects. If something looks different from the product description, ask for clarification before confirming your order.",
      },
      shipping: {
        title: "Shipping and Warehouse Considerations",
        content: "Shipping costs depend on weight, dimensions, destination and shipping line. Before finalizing any purchase, estimate the shipping cost using available calculators and consider warehouse consolidation options. Combining multiple items into a single shipment can reduce overall costs. Always review the warehouse storage policy to understand how long items can be held before shipping.",
      },
      safety: {
        title: "Safety Checklist Before Buying",
        content: "Before completing any purchase, verify the seller link, check current prices, confirm product availability, review size charts, examine QC photos, understand shipping restrictions and confirm the final total cost including shipping and any applicable fees. Never share your account password and always use secure payment methods.",
      },
      conclusion: {
        title: "Conclusion",
        content: "CSSBuy Spreadsheet is a valuable starting point for organizing product research, but it should be used as a reference tool rather than a guarantee of quality or authenticity. Always verify current information directly on the platform before purchasing. By following the research and safety practices outlined in this guide, you can make more informed decisions and reduce the risk of unexpected issues.",
      },
    },
    cta: "Continue Your Research on Main Website",
  },
};